import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { Link } from "react-router-dom";
import { gsap } from "gsap";
import img1 from "../assets/img1.png";
import "./footer.css";
import adani from "../assets/adani.png";
import aps from "../assets/aps.png";

import deye from "../assets/deye.png";
import ltenergy from "../assets/ltenergy.png";
import havells from "../assets/havells.png";
import ksolares from "../assets/ksolare.png";
import phoneix from "../assets/phoenix.png";
import polycab from "../assets/polycab.png";
import rayzone from "../assets/rayzon.png";
import rrcable from "../assets/rrkabel.png";
import waree from "../assets/waaree.png";
import finder from "../assets/finder.png";

import sungrow from "../assets/sungrow.png";
import quotes from "../assets/quotes.png";
import house from "../assets/house.png";
// import right from "../assets/right.png";
// import left from "../assets/left.png";

const Footer = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const [direction, setDirection] = useState("next");
  const location = useLocation(); // Get the current path

  // section7
  const partners = [
    { id: "1", name: "Adani Solar", imgSrc: adani },

    { id: "2", name: "APS", imgSrc: aps },

    { id: "3", name: "Waaree", imgSrc: waree },
    { id: "4", name: "Rayzone", imgSrc: rayzone },
    { id: "5", name: "Sungrow", imgSrc: sungrow },
    { id: "6", name: "Deye", imgSrc: deye },
    { id: "7", name: "Ksolare", imgSrc: ksolares },
    { id: "8", name: "R R Cable", imgSrc: rrcable },
    { id: "9", name: " Havells", imgSrc: havells }, 
    { id: "10", name: "Polycab", imgSrc: polycab },
    { id: "11", name: " L & T energy ", imgSrc: ltenergy },
    { id: "12", name: "Finder ", imgSrc: finder },
    { id: "13", name: " Phoenix ", imgSrc: phoneix },
  ];

  // section 8
  const testimonials = [
    {
      text: "Switching to solar with Radiant Sun Energy has cut our energy costs significantly! Highly recommended for businesses.",
      author: "Dipesh Patel - P and D Foods & Beverages, Karamsad",
      image: house,
    },
    {
      text: "Radiant Sun Energy's solar solution has been a game-changer for us, reducing costs and boosting sustainability!",
      author: "Dashrathbhai Prajapati - Shaan Cinema",
      image: house,
    },
    {
      text: "Radiant Sun Energy provided an efficient solar setup that powers our lab seamlessly, saving us both time and money.",
      author: "Dr. Krunal Prajapati - Krunal Lab, Anand",
      image: house,
    },
    {
      text: "Excellent service and great savings! Radiant Sun Energy transformed our home with affordable and reliable solar power.",
      author: "Sandipbhai Patel - Laxmi Finance, Anand",
      image: house,
    },
    {
      text: "Installing solar with Radiant Sun Energy has been the best investment for our home—efficient, reliable, and eco-friendly!",
      author: "Dr. Krunal Prajapati - Krunal Lab, Anand",
      image: house,
    },
  ];

  // const nextTestimonial = () => {
  //   setDirection("next");
  //   setCurrentIndex((prevIndex) =>
  //     prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
  //   );
  // };

  // const prevTestimonial = () => {
  //   setDirection("prev");
  //   setCurrentIndex((prevIndex) =>
  //     prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
  //   );
  // };
  // section 8

  useEffect(() => {
    // GSAP animation
    const startX = -50; // Animation starts from left
    const endX = 0; // Animation ends at original position

    gsap.fromTo(
      ".responsive-title, .responsive-text, .responsive-author",
      { opacity: 0, x: startX },
      {
        opacity: 1,
        x: endX,
        duration: 0.8,
        ease: "power3.out",
        stagger: 0.2, // Delays between elements
      }
    );

    // Set timer to change testimonial every few seconds
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 2000); // Change testimonial every 5 seconds

    return () => clearInterval(timer); // Cleanup timer
  }, [currentIndex, testimonials.length]);

  const isAboutUsPage = location.pathname === "/about-us";
  return (
    <>
      {/* section 7 */}
      <div
        className="container-fluid mb-1"
        style={{ overflow: "hidden", width: "100%" }}
      >
        {/* <div className="d-flex flex-column align-items-center">
         
          <div className="d-flex align-items-center justify-content-center gap-3">
            <span className="display-1 fw-bold">Our</span>
            <span
              style={{
                background: "linear-gradient(to right, #FF5E43, #FB992E)",
                WebkitBackgroundClip: "text",
                color: "transparent",
              }}
              className="display-1 fw-bold"
            >
              Partner
            </span>
          </div>

      
          <div className="d-flex marquee py-4 ">
            {partners.map((partner) => (
              <img
                key={partner.id}
                src={partner.imgSrc}
                alt={partner.name}
                className="partner-logo img-fluid"
              />
            ))}
          </div>
        </div> */}
        {!isAboutUsPage && (
          <div
            className="container-fluid mb-1"
            style={{ overflow: "hidden", width: "100%" }}
          >
            <div className="d-flex flex-column align-items-center">
              <div className="d-flex align-items-center justify-content-center gap-3">
                <span className="display-1 fw-bold">Our</span>
                <span
                  style={{
                    background: "linear-gradient(to right, #FF5E43, #FB992E)",
                    WebkitBackgroundClip: "text",
                    color: "transparent",
                  }}
                  className="display-1 fw-bold"
                >
                  Partner
                </span>
              </div>

              <div className="d-flex marquee py-4">
                {partners.map((partner) => (
                  <img
                    key={partner.id}
                    src={partner.imgSrc}
                    alt={partner.name}
                    className="partner-logo img-fluid"
                  />
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      <section style={{ width: "100%" }} className="p-3">
        <div className="container-fluid">
          <div className="row align-items-center">
            {/* Left Section for the Text */}
            <div className="col-12 col-md-6">
              <div
                style={{ lineHeight: "1" }}
                className="display-2 heading fw-bold"
              >
                <span>What</span>
                <div
                  style={{
                    background: "linear-gradient(to right, #FF5E43, #FB992E)",
                    WebkitBackgroundClip: "text",
                    color: "transparent",
                    lineHeight: "1",
                  }}
                >
                  People
                </div>
                <span
                  style={{
                    background: "linear-gradient(to right, #FF5E43, #FB992E)",
                    WebkitBackgroundClip: "text",
                    color: "transparent",
                    lineHeight: "1.2",
                  }}
                >
                  Say
                </span>
              </div>
              <div
                style={{
                  background: "linear-gradient(to right, #FFF8F4, #FFD1BA)",
                  minHeight: "25vh",
                }}
                className="p-3 rounded mt-2 cut-box position-relative testimonial-content"
              >
                <h5 className="fw-bold responsive-title">Amazing Service!!</h5>
                <p className="fw-semibold responsive-text description">
                  {`"${testimonials[currentIndex].text}"`}
                </p>

                <p className="fw-bold responsive-author">
                  {`- ${testimonials[currentIndex].author}`}
                </p>
              </div>
            </div>

            {/* Right Section for the Image */}
            <div className="col-12 col-md-6 position-relative testimonial-content">
              <img
                style={{
                  width: "170px",
                  position: "absolute",
                  top: "60px",
                  left: "-150px",
                  zIndex: -1,
                }}
                src={quotes}
                alt="Quotes"
              />
              <img
                src={testimonials[currentIndex].image}
                alt="Solar House"
                className="img-fluid rounded"
              />
            </div>
          </div>

          {/* Navigation Buttons */}
          {/* <div className="d-flex justify-content-end mt-3">
            <button
              type="button"
              className="btn rounded-circle d-inline d-md-block"
              onClick={prevTestimonial}
              style={{
                border: "none",
                width: "50px",
                height: "50px",
                background: "linear-gradient(to right, #FF5E43, #FB992E)",
              }}
            >
              <img src={left} alt="Previous" />
            </button>
            <button
              type="button"
              className="btn rounded-circle d-inline  d-md-block ms-2"
              onClick={nextTestimonial}
              style={{
                border: "none",
                width: "50px",
                height: "50px",
                background: "linear-gradient(to right, #FF5E43, #FB992E)",
              }}
            >
              <img src={right} alt="Next" />
            </button>
          </div> */}
        </div>
      </section>

      <footer
        style={{
          width: "100%",
          height: "40%",
          background: "linear-gradient(to right, #FFF8F4, #FFD1BA)",
        }}
        className="footer mt-5 "
      >
        <div className="container-fluid  ">
          <div style={{ color: "#1A2A3F" }} className="row   px-5 py-3">
            <div className="col-md-3 col-lg-5 col-sm-6 col-xs-12 p-2">
              <img src={img1} />
              <p className="fs-5 mt-3 fw-semibold ">
                Empower Your Future with Solar Energy Solutions. <br />
                Illuminate Your World, Sustainably. Radiant Energy, <br />
                Limitless Potential.
              </p>
              <div className="d-flex gap-3">
                {/* Whatsapp  */}
                <a
                  href="https://wa.me/918154000349"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" rounded-circle    overflow-hidden d-flex align-items-center justify-content-center"
                  style={{
                    width: 35,
                    height: 35,
                    color: "#000",
                    cursor: "pointer",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="#1A2A3F"
                    className="bi bi-whatsapp"
                    viewBox="0 0 16 16"
                  >
                    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                  </svg>
                </a>
                {/* Instrgram  */}
                <a
                  href="https://www.instagram.com/radiantsunenergy/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rounded-circle  overflow-hidden d-flex align-items-center justify-content-center"
                  style={{
                    width: 35,
                    height: 35,
                    color: "#000",
                    cursor: "pointer",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="#1A2A3F"
                    className="bi bi-instagram"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
                  </svg>
                </a>
                {/* Twitter  */}
                {/* <div
                  className="rounded-circle  overflow-hidden d-flex align-items-center justify-content-center"
                  style={{
                    width: 35,
                    height: 35,
                    color: "#000",
                    cursor: "pointer",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="#1A2A3F"
                    className="bi bi-twitter-x"
                    viewBox="0 0 16 16"
                  >
                    <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
                  </svg>
                </div> */}
                {/* Facebook  */}
                <a
                  href="https://www.facebook.com/radiantsunenergy?mibextid=ZbWKwL"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rounded-circle  overflow-hidden d-flex align-items-center justify-content-center"
                  style={{
                    width: 35,
                    height: 35,
                    color: "#000",
                    cursor: "pointer",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    fill="#1A2A3F"
                    className="bi bi-facebook"
                    viewBox="0 0 16 16"
                  >
                    <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
                  </svg>
                </a>
              </div>
            </div>
            <div className="col-md-2 mt-2 col-lg-2 col-sm-1 col-xs-6 p-2 ">
              <h5 className="fs-3 fw-bolder">Company</h5>
              <ul className="fs-5 list-unstyled fw-semibold">
                <li className="mb-2">
                  <Link
                    style={{ textDecoration: "none", color: "#1A2A3F" }}
                    to="/"
                  >
                    Home
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    style={{ textDecoration: "none", color: "#1A2A3F" }}
                    to="/about-us"
                  >
                    About Us
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    style={{ textDecoration: "none", color: "#1A2A3F" }}
                    to="/projects"
                  >
                    Our Project
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    style={{ textDecoration: "none", color: "#1A2A3F" }}
                    to="/products"
                  >
                    Our Product
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    style={{ textDecoration: "none", color: "#1A2A3F" }}
                    to="/contact-us"
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            <div className="col-md-3 mt-2 col-lg-2 col-sm-3 col-xs-6 p-2 ">
              <h5 className="fs-3 fw-bolder">Our Product</h5>
              <ul className=" fs-5 list-unstyled fw-semibold">
                <li className="mb-2">
                  <li>Residential Solar</li>
                </li>
                <li className="mb-2">
                  <p>Industrial Solar</p>
                </li>
              </ul>
            </div>

            <div className="col-md-4 col-lg-3 col-sm-6 mt-2 ">
              <h5 className="fs-3 fw-bolder">Contact Us</h5>
              <p className="fs-5 fw-semibold mb-1">
                Address: <br />
                405, RADHA SWAMI SAMYAK,
                <br />
                nr. JK LIGHT,
                <br />
                Patel Chokdi,
                <br />
                Lambhvel Rd,
                <br />
                Anand, 388001, Gujarat, India
              </p>
              <a
                style={{ color: "#1A2A3F" }}
                href="https://www.google.com/maps/dir//RADHA+SWAMI+SAMYAK,+405,+Lambhvel+Rd,+nr.+JK+LIGHT,+Patel+Chokdi,+Vivekanand+Wadi,+Anand,+Gujarat+388001/@22.5624124,72.8641671,12z/data=!3m1!4b1!4m8!4m7!1m0!1m5!1m1!1s0x395e4f7f929cd971:0xe06d7e999e75cc66!2m2!1d72.9465687!2d22.5624334?entry=ttu&g_ep=EgoyMDI0MTExMC4wIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
                className=" fs-4  fw-semibold "
              >
                Get Directions{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-arrow-right "
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                  />
                </svg>
              </a>
              <p className="fs-5 fw-semibold mb-1">
                For Inquiry:{" "}
                <a
                  href="tel:+918154000349"
                  style={{ textDecoration: "none", color: "#1A2A3F" }}
                >
                  +91 8154000349
                </a>
                ,{" "}
                <a
                  href="tel:+912692350300"
                  style={{ textDecoration: "none", color: "#1A2A3F" }}
                >
                  02692 350300
                </a>
              </p>
              <p className="fs-5 fw-semibold ">
                For Complaint:{" "}
                <a
                  href="tel:+918154000350"
                  style={{ textDecoration: "none", color: "#1A2A3F" }}
                >
                  +91 8154000350
                </a>
              </p>
              <a
                href="https://wa.me/918154000349"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  bottom: "20px",
                  color: "#25d366",
                  cursor: "pointer",
                  fontSize: "50px",
                  position: "fixed",
                  right: "20px",
                  zIndex: "999",
                  // zIndex: "1",
                }}
                className="whatsapp"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  stroke="currentColor"
                  strokeWidth="0"
                >
                  <path d="M12.001 2C17.5238 2 22.001 6.47715 22.001 12C22.001 17.5228 17.5238 22 12.001 22C10.1671 22 8.44851 21.5064 6.97086 20.6447L2.00516 22L3.35712 17.0315C2.49494 15.5536 2.00098 13.8345 2.00098 12C2.00098 6.47715 6.47813 2 12.001 2ZM8.59339 7.30019L8.39232 7.30833C8.26293 7.31742 8.13607 7.34902 8.02057 7.40811C7.93392 7.45244 7.85348 7.51651 7.72709 7.63586C7.60774 7.74855 7.53857 7.84697 7.46569 7.94186C7.09599 8.4232 6.89729 9.01405 6.90098 9.62098C6.90299 10.1116 7.03043 10.5884 7.23169 11.0336C7.63982 11.9364 8.31288 12.8908 9.20194 13.7759C9.4155 13.9885 9.62473 14.2034 9.85034 14.402C10.9538 15.3736 12.2688 16.0742 13.6907 16.4482C13.6907 16.4482 14.2507 16.5342 14.2589 16.5347C14.4444 16.5447 14.6296 16.5313 14.8153 16.5218C15.1066 16.5068 15.391 16.428 15.6484 16.2909C15.8139 16.2028 15.8922 16.159 16.0311 16.0714C16.0311 16.0714 16.0737 16.0426 16.1559 15.9814C16.2909 15.8808 16.3743 15.81 16.4866 15.6934C16.5694 15.6074 16.6406 15.5058 16.6956 15.3913C16.7738 15.2281 16.8525 14.9166 16.8838 14.6579C16.9077 14.4603 16.9005 14.3523 16.8979 14.2854C16.8936 14.1778 16.8047 14.0671 16.7073 14.0201L16.1258 13.7587C16.1258 13.7587 15.2563 13.3803 14.7245 13.1377C14.6691 13.1124 14.6085 13.1007 14.5476 13.097C14.4142 13.0888 14.2647 13.1236 14.1696 13.2238C14.1646 13.2218 14.0984 13.279 13.3749 14.1555C13.335 14.2032 13.2415 14.3069 13.0798 14.2972C13.0554 14.2955 13.0311 14.292 13.0074 14.2858C12.9419 14.2685 12.8781 14.2457 12.8157 14.2193C12.692 14.1668 12.6486 14.1469 12.5641 14.1105C11.9868 13.8583 11.457 13.5209 10.9887 13.108C10.8631 12.9974 10.7463 12.8783 10.6259 12.7616C10.2057 12.3543 9.86169 11.9211 9.60577 11.4938C9.5918 11.4705 9.57027 11.4368 9.54708 11.3991C9.50521 11.331 9.45903 11.25 9.44455 11.1944C9.40738 11.0473 9.50599 10.9291 9.50599 10.9291C9.50599 10.9291 9.74939 10.663 9.86248 10.5183C9.97128 10.379 10.0652 10.2428 10.125 10.1457C10.2428 9.95633 10.2801 9.76062 10.2182 9.60963C9.93764 8.92565 9.64818 8.24536 9.34986 7.56894C9.29098 7.43545 9.11585 7.33846 8.95659 7.32007C8.90265 7.31384 8.84875 7.30758 8.79459 7.30402C8.66053 7.29748 8.5262 7.29892 8.39232 7.30833L8.59339 7.30019Z"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
